/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 31 2023
 **/

import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { OpenPeopleDetailIsLoadedAtom, OpenPeopleDetailUserID } from "@/frameworks/core/components";
import { Configure } from "@/frameworks/libraries";

import { usePersistUser, usePersistActions } from "../../persistence";

export default function usePeopleDetail() {
	const isLoading = useAtomValue(OpenPeopleDetailIsLoadedAtom);
	const userID = useAtomValue(OpenPeopleDetailUserID);
	const userData = usePersistUser(userID);
	const isMe = userID === Configure.userID;

	const userActions = usePersistActions().users;
	useEffect(() => {
		userID && userActions.refresh_user(userID);
	}, [userID]);

	return {
		userData,
		userID,
		isLoading,
		isMe
	};
}
